import getMomentDateObj from "../functions/getMomentDateObj"
import getMomentNow from "../functions/getMomentNow"

export const useFilteredMovies = (
    overview_filter_movies_with_attribute,
    hide_no_performance_movies,
    movies,
    timezone
) => {
    let filteredMovies = {
        items: {},
        order: []
    }

    if (overview_filter_movies_with_attribute && overview_filter_movies_with_attribute.length !== 0) {
        movies.order.map(moviePk => {
            const movie = movies.items[moviePk]
            const { technologyAttributes, performances, limitations } = movie
            const { visibleFrom } = limitations
            const technogolyAttributesIds = []
            let hideAllPerformances = false

            if (visibleFrom) {
                const performanceDate = getMomentDateObj(visibleFrom, timezone)
                hideAllPerformances = getMomentNow(timezone).isBefore(performanceDate)
            }


            if (technologyAttributes && technologyAttributes.length !== 0) {
                technologyAttributes.map(attr => {
                    //for when "Vorschau" movies get performances to show and aren't empty anymore
                    if (attr.name.toLowerCase() === 'vorschau' && performances.length > 0 && !hideAllPerformances) {
                        return ''
                    } else {
                        technogolyAttributesIds.push(attr.id)
                    }
                })
            }

            const compareArrays = _.intersection(overview_filter_movies_with_attribute, technogolyAttributesIds)

            if (compareArrays.length === 0) {
                filteredMovies.order.push(moviePk)
                filteredMovies.items[moviePk] = movie
            }
        })
    } else {
        filteredMovies = movies
    }

    if(hide_no_performance_movies) {
        let moviesWithPerformances = {
            items: {},
            order: []
        }

        filteredMovies.order.map(moviePk => {
            const movie = movies.items[moviePk]
            const { performances } = movie

            if(performances.length > 0) {
                moviesWithPerformances.order.push(moviePk)
                moviesWithPerformances.items[moviePk] = movie
            }
        })

        filteredMovies = moviesWithPerformances
    }

    return filteredMovies
}

